import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * A cart line-item quantity selector rendered as a native dropdown.
 *
 * Mirrors the event-driven contract of the stepper (`cart-quantity-selector-component`):
 * on `change` it dispatches a `QuantitySelectorUpdateEvent`, which the parent
 * `cart-items-component` listens for (debounced) and turns into a `/cart/change` request
 * plus a section morph. This component performs no network calls itself.
 *
 * The `on:change="/onChange"` attribute on the inner `<select>` routes here via the
 * theme's delegated event system.
 *
 * @extends {Component}
 */
class CartQuantityDropdownComponent extends Component {
  /**
   * Handles the dropdown change and broadcasts the new cart quantity.
   * @param {Event} event - The change event, whose target is the `<select>`.
   */
  onChange(event) {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;

    const quantity = parseInt(select.value, 10);
    if (Number.isNaN(quantity)) return;

    const cartLine = Number(select.dataset.cartLine) || undefined;

    this.dispatchEvent(new QuantitySelectorUpdateEvent(quantity, cartLine));
  }
}

if (!customElements.get('cart-quantity-dropdown-component')) {
  customElements.define('cart-quantity-dropdown-component', CartQuantityDropdownComponent);
}
